import React from 'react';

interface EmbeddedModeLoaderProps {
  message?: string;
}

/**
 * Loading component shown while waiting for external token authentication
 * in embedded mode. Uses simple divs and CSS.
 */
export const EmbeddedModeLoader: React.FC<EmbeddedModeLoaderProps> = ({
  message = 'Waiting for authentication from parent application...',
}) => {
  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          gap: 'var(--spacing-lg)',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
          }}
        />

        <p style={{ color: '#666', margin: 0 }}>{message}</p>
      </div>
    </>
  );
};
